import React from 'react'
import axios from 'axios'
import MediaLibrary from './../components/media_library'
import VideoLibrary from './../components/video_library'
import Cast from './../components/cast'

let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const renderPrettyDateRange = dates => {
		let start_date = new Date(dates[0].date)
		start_date = new Date(start_date.getTime() - start_date.getTimezoneOffset() * -60000)
		start_date = months[start_date.getMonth()] + ' ' + start_date.getDate()

		let end_date = new Date(dates[dates.length - 1].date)
		end_date = new Date(end_date.getTime() - end_date.getTimezoneOffset() * -60000)
		end_date = '-' + end_date.getDate() + ', ' + end_date.getFullYear()

		return <div>{start_date + end_date}</div>
}

const renderDates = dates => {
	return dates.map( (item, i) => {
		let show_date = new Date(item.date)
		show_date = new Date(show_date.getTime() - show_date.getTimezoneOffset() * -60000)
		show_date = days[show_date.getDay()] + ', ' + months[show_date.getMonth()] + ' ' + show_date.getDate() + ', ' + show_date.getFullYear()

		let show_time = item.time.split(':')
		show_time = (show_time[0] % 12 || 12) + ':' + show_time[1] + (show_time[0] > 11 ? 'pm' : 'am')

		return <div key={i}><strong>{show_date}</strong> @ {show_time}</div>
	})
}

class Show extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			item: {},
			cast: [],
			showId: null
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'shows'
			}
		}).then( response => {
			const item = response.data.items.filter( item => this.props.id ? item.id === this.props.id : item.isHero )

			if(item.length){
				this.setState({
					item: item[0],
					showId: item[0].id
				})
			}
		})
		.then( () => this.fetchBiosData() )
	}

	fetchBiosData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'bios'
			}
		}).then( response => {
			let data = response.data.items.filter( bio => bio.show_id === this.state.showId )
			if(this.refs.showRef){
				this.setState({
					cast: data.sort( (a, b) => {
						let nameA = a.lastname.toLowerCase(), nameB = b.lastname.toLowerCase()
						if(nameA < nameB)
							return -1
						if(nameA > nameB)
							return 1
						return 0
					})
				})
			}
		})
	}

	render() {
		return (
			<div className="show" ref="showRef">
				{ this.state.item.title ?
						this.props.hero ?
							<h2>{decodeURIComponent(this.state.item.title)}</h2> :
							<h3>{decodeURIComponent(this.state.item.title)}</h3>
						: null
				}

				{ this.state.item.banner ?
					<img src={this.state.item.banner} alt={this.state.item.title} /> :
					null
				}

				{ this.state.item.description ?
					<p className="description">{decodeURIComponent(this.state.item.description)}</p> :
					null
				}

				{ this.state.item.title !== 'Vintage%20Hitchcock%3A%20A%20Live%20Radio%20Play' && this.state.item.performance_dates && this.state.item.performance_dates.length ?
					<div>
						<h3>Performance Dates</h3>
						{ this.props.hero ? renderDates(this.state.item.performance_dates) : renderPrettyDateRange(this.state.item.performance_dates) }
					</div> :
					null
				}

				{ this.state.item.title === 'Vintage%20Hitchcock%3A%20A%20Live%20Radio%20Play' && <div>
						<h3>Special Streaming Event</h3>
						<div>Available to view between <strong>Friday, November 20, 2020</strong> @ 7pm and <strong>Saturday, November 21, 2020</strong> @ 11:59pm</div>
					</div>
				}

				{ this.state.item.ticketsOnSale ?
					<a href="https://app.arts-people.com/index.php?ticketing=dehs" className="ticket_cta">Buy Tickets</a> :
					null
				}

				{ this.state.item.directors_notes ?
					<div>
						<h3>Director's Notes</h3>
						<p className="description">{decodeURIComponent(this.state.item.directors_notes)}</p>
					</div> :
					null
				}

				{ this.state.item.producers_notes ?
					<div>
						<h3>Producer's Notes</h3>
						<p className="description">{decodeURIComponent(this.state.item.producers_notes)}</p>
					</div> :
					null
				}

				{ this.state.item.show_staff && this.state.item.show_staff.length ?
					<div>
						<h3>Staff</h3>
						{ this.state.item.show_staff.map( (item, i) => <div key={i}><strong>{decodeURIComponent(item.title)}</strong> {decodeURIComponent(item.name)}</div>)}
					</div> :
					null
				}

				<Cast cast={this.state.cast} />
				<MediaLibrary media_library={this.state.item.media_library} />
				<VideoLibrary video_library={this.state.item.video_library} />

				{ this.state.item.show_credits && this.state.item.show_credits.length ?
					<div>
						<h3>Original Credits</h3>
						{ this.state.item.show_credits.map( (item, i) => <div key={i}><strong>{decodeURIComponent(item.title)}</strong> {decodeURIComponent(item.name)}</div>)}
					</div> :
					null
				}
			</div>
		)
	}
}

export default Show



// WEBPACK FOOTER //
// ./src/components/show.js